import { createCustomAction, createStandardAction } from 'typesafe-actions'

export const popupActions = {
  popup: {
    position: {
      set: createCustomAction('POPUP/POSITION/SET', type => {
        return (top: number, left: number) => ({ type, payload: { top, left } })
      }),
      takeFrom: createStandardAction('POPUP/POSITION/TAKE_FROM')<HTMLElement>()
    },
    show: createStandardAction('POPUP/SHOW')<undefined>(),
    hide: createStandardAction('POPUP/HIDE')<undefined>()
  }
}
